// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminTransactionRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminTransactionRow — one row for GET /subscriptions/admin/transactions.
 *
 * All Subscriptions_TransactionRow fields plus franquia_id and franchise_name so
 * the staff surface can display cross-franchise revenue at a glance.
 *
 * Datetime fields are ISO-8601 UTC strings (controller converts GMT-3 before fromRows()).
 * attempts is the ordered attempt sequence for this charge (chronological ASC) —
 * populated for subscription-linked rows from subscription_events, and for
 * kind='credit_purchase' rows derived from ai_credit_purchases status transitions.
 */
import type { Subscriptions_TransactionAttemptRow } from './Subscriptions_TransactionAttemptRow'
import { registerContract } from './validate'

export interface Subscriptions_AdminTransactionRow {
id: number
subscription_id: number
franquia_id: number
franchise_name?: string
kind?: string
amount_cents?: number
currency?: string
status?: string
provider?: string
provider_charge_id?: string
paid_at?: string
created_at?: string
attempts?: Subscriptions_TransactionAttemptRow[]
}

registerContract('Subscriptions_AdminTransactionRow', {
  id:                 { type: 'number',  required: true },
  subscription_id:    { type: 'number',  required: true },
  franquia_id:        { type: 'number',  required: true },
  franchise_name:     { type: 'string',  required: false },
  kind:               { type: 'string',  required: false },
  amount_cents:       { type: 'number',  required: false },
  currency:           { type: 'string',  required: false },
  status:             { type: 'string',  required: false },
  provider:           { type: 'string',  required: false },
  provider_charge_id: { type: 'string',  required: false },
  paid_at:            { type: 'string',  required: false },
  created_at:         { type: 'string',  required: false },
  attempts: {
    type: 'array',
    required: false,
    items: {
      status:     { type: 'string',  required: false },
      event_type: { type: 'string',  required: false },
      created_at: { type: 'string',  required: false },
    },
  },
})
